// extracted by mini-css-extract-plugin
export var reviews = "style-module--reviews--c5564";
export var reviews__container = "style-module--reviews__container--9d553";
export var reviews__name = "style-module--reviews__name--1d081";
export var reviews__nav = "style-module--reviews__nav--e17ae";
export var reviews__slide = "style-module--reviews__slide--7d89c";
export var reviews__swiper = "style-module--reviews__swiper--0fbf1";
export var reviews__text = "style-module--reviews__text--3f054";
export var reviews__videoBg = "style-module--reviews__video-bg--1fccd";
export var reviews__videoFrame = "style-module--reviews__video-frame--818d6";
export var reviews__wrapper = "style-module--reviews__wrapper--e59ea";
export var swiperButtonNext = "style-module--swiper-button-next--dfc7a";
export var swiperButtonPrev = "style-module--swiper-button-prev--62036";